import { OnlineOrderDeliveryMode } from '@app/graphql/types/graphql';
import { useTranslate } from '@tolgee/react';

interface DeliveryButtonProps {
  mode: OnlineOrderDeliveryMode | undefined | null;
  className?: string;
}

export default function DeliveryButton({ mode }: DeliveryButtonProps) {
  const { t } = useTranslate();

  if (!mode) {
    return null;
  }

  const getDeliveryModeLabel = (mode: OnlineOrderDeliveryMode) => {
    switch (mode) {
      case OnlineOrderDeliveryMode.Delivery:
        return t('storefront.online-order.delivery-mode.delivery', 'Delivery');
      case OnlineOrderDeliveryMode.Pickup:
        return t('storefront.online-order.delivery-mode.pickup', 'Pickup');
      default:
        return mode;
    }
  };

  const getDeliveryModeIcon = (mode: OnlineOrderDeliveryMode) => {
    switch (mode) {
      case OnlineOrderDeliveryMode.Delivery:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
            />
          </svg>
        );
      case OnlineOrderDeliveryMode.Pickup:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
            />
          </svg>
        );
    }
  };

  return (
    <button
      type="button"
      className="delivery-btn flex items-center justify-center gap-x-1 rounded-lg border border-indigo-500 bg-indigo-100 px-4 py-2 text-indigo-600"
    >
      <span className="delivery-btn__icon">{getDeliveryModeIcon(mode)}</span>
      <span className="delivery-btn__text">{getDeliveryModeLabel(mode)}</span>
    </button>
  );
}
